import React, { useEffect } from 'react'
import { Button, Card, CardBody, CardTitle, Col, Form, Input, Label, Row, FormFeedback } from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";
import { updateAdminSettings } from 'helpers/API Calls/System & Settings/Admin Settings';

function BookingCharges({data}: any) {

  const formik = useFormik({
    initialValues: {
      enableVAT: false,
      vatAmount: '',
      enableDeposit: false,
      depositAmount: ''
    },    
    validationSchema: yup.object().shape({
      enableVAT: yup.boolean(),
      vatAmount: yup.string().when(['enableVAT'], {
        is: true,
        then: () => yup.string()
          .required('VAT amount is required')
          .matches(/^\d+(\.\d{1,2})?$/, 'Must be a valid amount')
          .test('range', 'VAT amount must be greater than or equal to 0', 
            (value) => !value || parseFloat(value) >= 0)
      }),
      enableDeposit: yup.boolean(),
      depositAmount: yup.string().when(['enableDeposit'], {
        is: true,
        then: () => yup.string()
          .required('Deposit amount is required')
          .matches(/^\d+(\.\d{1,2})?$/, 'Must be a valid amount')
          .test('range', 'Deposit amount must be greater than or equal to 0', 
            (value) => !value || parseFloat(value) >= 0)
      })
    }),
    onSubmit: async (values: any, { setSubmitting }) => {
      setSubmitting(true);
      const reqData = [
      {
        key: "VAT_VALUE",
        value: values.enableVAT ? `${values.vatAmount}` : '0',
        id: data.VAT_VALUE.id,
      },
      {
        key: "REFUNDABLE_CLEANING_DEPOSIT",
        value: values.enableDeposit ? `${values.depositAmount}` : '0',
        id: data.REFUNDABLE_CLEANING_DEPOSIT.id,
      }
    ]
      const response = await updateAdminSettings({'settings' : reqData});
      if (response) {
        setSubmitting(false);
      }
    }
  });  
  
  useEffect(() => {
    if (data) {
      formik.setValues({
        enableVAT: data?.VAT_VALUE?.value !== '0' && data?.VAT_VALUE?.value !== '',
        vatAmount: data?.VAT_VALUE?.value || '',
        enableDeposit: data?.REFUNDABLE_CLEANING_DEPOSIT?.value !== '0' && data?.REFUNDABLE_CLEANING_DEPOSIT?.value !== '',
        depositAmount: data?.REFUNDABLE_CLEANING_DEPOSIT?.value || ''
      });
    }
},[data])

  // Add scroll to error effect
  useEffect(() => {
  if (Object.keys(formik.errors).length > 0 && formik.isSubmitting) {
      const firstErrorKey = Object.keys(formik.errors)[0];
      const element = document.getElementById(firstErrorKey);
      if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.focus();
      }
  }
  }, [formik.errors, formik.isSubmitting]);
      
  return (
    <Card>
        <CardBody>
        <CardTitle tag="h4" className='mb-4'>Booking Charges</CardTitle>
        <Form onSubmit={formik.handleSubmit} autoComplete="off">
            <div className="mb-4">
                <div className="mb-3">
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="enableVAT"
                      name="enableVAT"
                      checked={formik.values.enableVAT}
                      onChange={formik.handleChange}
                      disabled={data?.VAT_VALUE?.can_update !== 1}
                    />
                    <Label className="form-check-label" htmlFor="enableVAT">
                      Enable VAT
                    </Label>
                  </div>
                </div>

            {formik.values.enableVAT && (
                <Row>
                <Col sm="6">
                    <div >                    
                    <Label htmlFor="vatAmount">VAT Percentage <span className="text-danger">*</span></Label>
                    <Input
                        id="vatAmount"
                        name="vatAmount"
                        type="number"
                        // step="0.01"
                        placeholder="Enter VAT amount"
                        value={formik.values.vatAmount}
                        onChange={formik.handleChange}
                        invalid={formik.touched.vatAmount && formik.errors.vatAmount ? true : false}
                        disabled={data?.VAT_VALUE?.can_update !== 1}
                    />                    
                    {formik.errors.vatAmount && formik.touched.vatAmount && (
                        <FormFeedback type="invalid">{String(formik.errors.vatAmount)}</FormFeedback>
                    )}
                    </div>
                </Col>
                </Row>
            )}
            </div>            
            <div className="mb-4">
                <div className="mb-3">
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="enableDeposit"
                      name="enableDeposit"
                      checked={formik.values.enableDeposit}
                      onChange={formik.handleChange}
                      disabled={data?.REFUNDABLE_CLEANING_DEPOSIT?.can_update !== 1}
                    />
                    <Label className="form-check-label" htmlFor="enableDeposit">
                      Enable Refundable Deposit
                    </Label>
                  </div>
                </div>

            {formik.values.enableDeposit && (
                <Row>
                <Col sm="6">
                    <div className="mb-3">                    
                    <Label htmlFor="depositAmount">Deposit Amount <span className="text-danger">*</span></Label>
                    <Input
                        id="depositAmount"
                        name="depositAmount"
                        type="number"
                        // step="0.01"
                        placeholder="Enter deposit amount"
                        value={formik.values.depositAmount}
                        onChange={formik.handleChange}
                        invalid={formik.touched.depositAmount && formik.errors.depositAmount ? true : false}
                        disabled={data?.REFUNDABLE_CLEANING_DEPOSIT?.can_update !== 1}
                    />                    
                    {formik.errors.depositAmount && formik.touched.depositAmount && (
                        <FormFeedback type="invalid">{String(formik.errors.depositAmount)}</FormFeedback>
                    )}
                    </div>
                </Col>
                </Row>
            )}
            </div>

            <div className="d-flex flex-wrap gap-2 justify-content-end">
            <Button type="submit" color="primary" disabled={formik.isSubmitting}>
                {formik.isSubmitting ? 'Saving...' : 'Save Charges'}
            </Button>
            </div>
        </Form>
        </CardBody>
    </Card>
  )
}

export default BookingCharges
